/**
 * Test hook for the smoke test (tests/smoke.spec.ts), so it does not depend on where buttons are.
 * Each game registers how to start playing and, optionally, one "move" the test can repeat.
 * Harmless in production: it only exposes functions the player can trigger anyway.
 */
export interface SmokeHooks {
  /** Go from the first screen to an active level. */
  play(): void
  /** Perform one valid player action (a tap, a swap…). Called a few times by the smoke test. */
  move?(): void
  /** Where the lowest tappable thing is, in logical pixels of config/game.json size, so a test can tap it with a real pointer. */
  target?(): { x: number; y: number } | null
  /** Ask the host to close (the exit button of the title). Only for titles whose exit model is `host`. */
  exit?(): void
}

export function exposeSmoke(hooks: SmokeHooks) {
  ;(window as unknown as { __hitzSmoke: SmokeHooks }).__hitzSmoke = hooks
}
